module.exports = __webpack_public_path__ + "f14be4783fdf4b73c9d5cfd2f4ec1d25.svg";